export function parseDotPath(path) {
  const trimmed = path.trim();
  if (!trimmed) return [];
  const segments = trimmed.split('.');
  if (segments.some((segment) => segment.length === 0)) {
    throw new Error('路径不能包含空层级，例如连续的点或首尾点。');
  }
  return segments;
}

export function getAtPath(root, path) {
  let segments;
  try {
    segments = Array.isArray(path) ? path : parseDotPath(path);
  } catch (error) {
    return { found: false, error: error.message };
  }

  let current = root;
  for (const segment of segments) {
    if (current === null || typeof current !== 'object') {
      return { found: false };
    }
    if (!Object.prototype.hasOwnProperty.call(current, segment)) {
      return { found: false };
    }
    current = current[segment];
  }
  return { found: true, value: current, segments };
}

export function toJsonPointer(path) {
  const segments = Array.isArray(path) ? path : parseDotPath(path);
  if (segments.length === 0) return '';
  return `/${segments.map(escapePointerSegment).join('/')}`;
}

export function pathMatches(candidate, filter) {
  const normalized = filter.trim();
  if (!normalized) return true;
  return candidate === normalized
    || candidate.startsWith(`${normalized}.`)
    || normalized.startsWith(`${candidate}.`);
}

function escapePointerSegment(segment) {
  return segment.replaceAll('~', '~0').replaceAll('/', '~1');
}
